<template>
    <div @keyup.enter="submitForm" v-if="fetched">
        <d-list-group flush>
            <d-list-group-item class="p-3">
                <d-form-row>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.residence_street" name="residence_street" label="Ulica" placeholder="Ulica"></ss-input>
                    </d-col>
                    <d-col md="6">
                        <ss-input v-model="client.residence_house_number" name="residence_house_number" label="Nr budynku" placeholder="Nr budynku"></ss-input>
                    </d-col>
                </d-form-row>
                <d-form-row>
                    <d-col md="6">
                        <ss-input v-model="client.residence_flat_number" name="residence_flat_number" label="Nr lokalu" placeholder="Nr lokalu"></ss-input>
                    </d-col>
                </d-form-row>

                <d-form-row>
                    <d-col md="6" class="form-group">
                        <ss-input v-model="client.residence_postcode" name="residence_postcode" label="Kod pocztowy" placeholder="Kod pocztowy"></ss-input>
                    </d-col>
                    <d-col md="6">
                        <ss-input v-model="client.residence_city" name="residence_city" label="Miasto" placeholder="Miasto"></ss-input>
                    </d-col>
                </d-form-row>
            </d-list-group-item>
        </d-list-group>
    </div>
</template>

<script>
    import LarErrors from '../../helpers/Errors';

    export default {
        name: "AddressResidence",
        components: {
            LarErrors
        },
        props: {
            props: {
                type: Object,
                default: {}
            }
        },
        data(){
            return{
                lar_errors: LarErrors,
                fetched:    false,
                client: {
                    residence_street:          '',
                    residence_house_number:    '',
                    residence_postcode:        '',
                    residence_city:            '',
                    residence_flat_number:     ''
                }
            }
        },
        mounted(){
            this.client = this.props ? this.props : this.client;
            this.fetched = true;
        },
        watch: {
            props: {
                handler: function(to) {
                    this.client = to;
                    this.$forceUpdate();
                },
                deep: true
            }
        }
    }
</script>
